



























import MessageComponent from '@/shared/components/Message.vue'
import ScientistSearchResultCard from '../Scientists/ScientistSearchResultCard.vue'
import SearchResultsCount from './SearchResultsCount.vue'
import VUSearchResultCard from '../VU/VUSearchResultCard.vue'
import InfiniteScrollTrigger from '@/shared/components/InfiniteScrollTrigger.vue'
import {defineComponent} from "@vue/composition-api";
import {useGetters, useStore} from "vuex-composition-helpers";

export default defineComponent({
    name: 'SearchResults',
    components: {
        MessageComponent,
        ScientistSearchResultCard,
        SearchResultsCount,
        VUSearchResultCard,
        InfiniteScrollTrigger
    },
    props: {
        showCount: {type: Boolean, default: false},
        resultComponent: {type: String, required: true}
    },
    setup: () => {
        const {
            searchLoading,
            searchFailed,
            searchResultsCount,
            searchResults
        } = useGetters(['searchLoading', 'searchFailed', 'searchResultsCount', 'searchResults'])
        const {labels} = useGetters(['labels'])
        const store = useStore()

        async function loadMore() {
            if (!searchLoading.value && searchResultsCount.value > searchResults.value.length) {
                await store.dispatch('loadData', [])
            }
        }

        return {
            searchLoading,
            searchFailed,
            searchResultsCount,
            searchResults,
            labels,
            loadMore
        }
    }
})
